"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.payload = exports.initialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.dropdownOptions = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'retirepay';
var idPrefix = exports.idPrefix = 'glwb_';
var dropdownOptions = exports.dropdownOptions = {
  rollUpRate: ['3%', '4%', '5%', '6%', '7%'],
  rollUpPeriod: ['0 years', '1 year', '2 years', '3 years', '4 years', '5 years', '6 years', '7 years', '8 years', '9 years', '10 years', '11 years', '12 years', '13 years', '14 years', '15 years'],
  interestRollUp: ['Simple', 'Compound'],
  netGrowthNYArray: ['1.00%', '1.50%', '2.00%', '2.50%', '3.00%', '3.50%', '4.00%', '4.50%', '5.00%', '5.50%', '6.00%', '6.50%', '7.00%', '7.50%', '8.00%'],
  netGrowthNonNYArray: ['1.00%', '1.50%', '2.00%', '2.50%', '3.00%', '3.50%', '4.00%', '4.50%', '5.00%', '5.50%', '6.00%', '6.50%', '7.00%', '7.50%', '8.00%', '8.50%', '9.00%', '9.50%', '10.00%', '10.50%', '11.00%', '11.50%', '12.00%']
};
var validationPage1 = yup.object().shape({
  isSingleLife: yup.string().required('An option is required.'),
  issueAge: yup.number().transform(_utils.parseCurrencyString).required('Age must be between 45 and 80.').min(45, 'Age must be between 45 and 80.').max(80, 'Age must be between 45 and 80.'),
  isQualified: yup.string().required('An option is required.'),
  purchasePayment: yup.number().when('isQualified', {
    is: isQualified => isQualified == 'qualified',
    then: yup.number().transform(_utils.parseCurrencyString).required('Amount must be between $5,000 and $1,500,000.').min(5000, 'Amount must be between $5,000 and $1,500,000.').max(1500000, 'Amount must be between $5,000 and $1,500,000.'),
    otherwise: yup.number().transform(_utils.parseCurrencyString).required('Amount must be between $10,000 and $1,500,000.').min(10000, 'Amount must be between $10,000 and $1,500,000.').max(1500000, 'Amount must be between $10,000 and $1,500,000.')
  }),
  isNewYork: yup.string().required('An option is required.')
});
var arrayDefinition = yup.array().of(yup.object().shape({
  endAge: yup.number().required('Field cannot be left blank.').min(1, 'Must be greater than 0 and equal to or less than 99.').max(99, 'Must be greater than 0 and equal to or less than 99.').test((info, meta) => {
    var index = Number(meta.path.substring(meta.path.indexOf('[') + 1, meta.path.indexOf('[') + 2));
    var arraySelection = meta.path.substring(0, meta.path.indexOf('['));
    if (index > 0 && meta.from[1].value[arraySelection][index + 1]) {
      if (info >= meta.from[1].value[arraySelection][index + 1].startAge) {
        return meta.createError({
          path: "".concat(meta.path),
          message: "End age must be less than \n              ".concat(meta.from[1].value[arraySelection][index + 1].startAge, ".")
        });
      }
    }
    if (meta.parent.startAge === 99 && info < meta.parent.startAge) {
      return meta.createError({
        path: "".concat(meta.path),
        message: 'Your end age must be equal to the max of 99.'
      });
    }
    var endAgeGreaterThanOrEqualToStartAge = info >= meta.parent.startAge;
    return endAgeGreaterThanOrEqualToStartAge ? true : meta.createError({
      path: "".concat(meta.path),
      message: "Age must be at least ".concat(meta.parent.startAge, ".")
    });
  }),
  withdrawalRate: yup.number().transform(parseFloat).test((info, meta) => {
    if (!meta.path.includes('0') && info === undefined) {
      return meta.createError({
        path: "".concat(meta.path),
        message: 'Enter a rate between 0.00% - 20.00%.'
      });
    }
    if (!meta.path.includes('0') && info < 0) {
      return meta.createError({
        path: "".concat(meta.path),
        message: 'Enter a rate between 0.00% - 20.00%.'
      });
    }
    if (!meta.path.includes('0') && info > 20) {
      return meta.createError({
        path: "".concat(meta.path),
        message: 'Enter a rate between 0.00% - 20.00%.'
      });
    }
    return true;
  })
}));
var validationPage2 = yup.object().shape({
  singleLifeArray: yup.array().when(['isSingleLife', 'isNewYork'], {
    is: (isSingleLife, isNewYork) => isSingleLife == 'singleLife' && isNewYork == 'otherState',
    then: arrayDefinition
  }),
  jointLifeArray: yup.array().when(['isSingleLife', 'isNewYork'], {
    is: (isSingleLife, isNewYork) => isSingleLife == 'jointLife' && isNewYork == 'otherState',
    then: arrayDefinition
  }),
  nySingleArray: yup.array().when(['isSingleLife', 'isNewYork'], {
    is: (isSingleLife, isNewYork) => isSingleLife == 'singleLife' && isNewYork == 'newYork',
    then: arrayDefinition
  }),
  nyJointArray: yup.array().when(['isSingleLife', 'isNewYork'], {
    is: (isSingleLife, isNewYork) => isSingleLife == 'jointLife' && isNewYork == 'newYork',
    then: arrayDefinition
  }),
  rollUpRate: yup.string().required('You must select a roll-up rate').oneOf(dropdownOptions.rollUpRate),
  rollUpPeriod: yup.string().required('You must select a roll-up period').oneOf(dropdownOptions.rollUpPeriod),
  interestRollUp: yup.string().required('You must select an interest roll-up').oneOf(dropdownOptions.interestRollUp)
});
var validationPage3 = yup.object().shape({
  net_market_growth_rate: yup.string().required('You must select a rate')
});
var validationPage4 = yup.object().shape({
  net_market_growth_rate: yup.string().required('You must select a rate')
});
var validationConfig = exports.validationConfig = [validationPage1, validationPage2, validationPage3, validationPage4];
var initialValuesConfig = exports.initialValuesConfig = {
  isSingleLife: 'singleLife',
  issueAge: '57',
  isQualified: 'qualified',
  purchasePayment: '100,000',
  isNewYork: '',
  rollUpRate: '6%',
  rollUpPeriod: '10 years',
  interestRollUp: 'Simple',
  // Non-New York Arrays
  singleLifeArray: [{
    startAge: 0,
    endAge: 34,
    withdrawalRate: '0.00'
  }, {
    startAge: 35,
    endAge: 64,
    withdrawalRate: '4.00'
  }, {
    startAge: 65,
    endAge: 74,
    withdrawalRate: '5.25'
  }, {
    startAge: 75,
    endAge: 80,
    withdrawalRate: '5.50'
  }, {
    startAge: 81,
    endAge: 99,
    withdrawalRate: '5.75'
  }],
  jointLifeArray: [{
    startAge: 0,
    endAge: 34,
    withdrawalRate: '0.00'
  }, {
    startAge: 35,
    endAge: 64,
    withdrawalRate: '3.75'
  }, {
    startAge: 65,
    endAge: 74,
    withdrawalRate: '5.00'
  }, {
    startAge: 75,
    endAge: 80,
    withdrawalRate: '5.25'
  }, {
    startAge: 81,
    endAge: 99,
    withdrawalRate: '5.50'
  }],
  // New York arrays below
  nySingleArray: [{
    startAge: 0,
    endAge: 34,
    withdrawalRate: '0.00'
  }, {
    startAge: 35,
    endAge: 64,
    withdrawalRate: '4.00'
  }, {
    startAge: 65,
    endAge: 74,
    withdrawalRate: '5.25'
  }, {
    startAge: 75,
    endAge: 80,
    withdrawalRate: '5.50'
  }, {
    startAge: 81,
    endAge: 99,
    withdrawalRate: '5.75'
  }],
  nyJointArray: [{
    startAge: 0,
    endAge: 34,
    withdrawalRate: '0.00'
  }, {
    startAge: 35,
    endAge: 64,
    withdrawalRate: '3.75'
  }, {
    startAge: 65,
    endAge: 74,
    withdrawalRate: '5.00'
  }, {
    startAge: 75,
    endAge: 80,
    withdrawalRate: '5.25'
  }, {
    startAge: 81,
    endAge: 99,
    withdrawalRate: '5.50'
  }],
  net_market_growth_rate: '4.00%'
};
var initialTouchedConfig = exports.initialTouchedConfig = {};
var payload = exports.payload = {};
var propsConfig = exports.propsConfig = {
  config: {
    API_URL: 'https://www-qa.massmutual.com/ict/calculate/glwb_calculator_v0.0.1',
    CONTENT_API_CALC_PDF: 'https://maurice-api-qa.app.dx.nsawsnprd.massmutual.com/downloadpdf/calcpdf',
    Icon: '',
    Label: '',
    SecondaryStyle: true,
    HasBorder: true,
    Steps: [{
      Title: 'Client information',
      SecondaryDescription: '',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Product information',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: '',
        Side: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Select growth rate',
      Description: '',
      SecondaryDescription: 'Select a net growth rate. Note that rates for 0% market growth will always be reflected in the results.',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Income amounts',
      Description: '',
      SecondaryDescription: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Download as a PDF',
        Icon: 'icon-download',
        Variant: 'primary',
        Side: 'R',
        HideNext: false
      },
      RightHandButton: {
        Label: '',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }]
  }
};